import { FreshServiceProposalWash } from "@repo/common"
import { useFieldContext } from "../hooks/form-contexts"
import { ServiceProposalWashCard } from "./service-proposal-wash-card"

export interface ServiceProposalPackageWashFieldProps {
  packageWash: FreshServiceProposalWash
  packageId: string
}

export const ServiceProposalPackageWashField = ({
  packageWash,
  packageId,
}: ServiceProposalPackageWashFieldProps) => {
  const field = useFieldContext<{
    originalPackageId: string
    selectedWashOriginalId?: string
  }>()

  const currentPackage = field.state.value
  const isThisPackage = currentPackage.originalPackageId === packageId
  const isWashSelected =
    isThisPackage &&
    currentPackage.selectedWashOriginalId === packageWash.originalWashId

  return (
    <ServiceProposalWashCard
      data={packageWash}
      selected={isWashSelected}
      onSelect={() => {
        if (!isThisPackage) return

        field.handleChange({
          ...currentPackage,
          selectedWashOriginalId: isWashSelected
            ? undefined
            : packageWash.originalWashId,
        })
      }}
      interactive={isThisPackage}
      hidePrice={true}
    />
  )
}
